<template>
  <div class="bcb-campaign-assign-reviewers">
    <p class="text-muted">
      Chỉ định TRƯỚC tài khoản sẽ ký làm BS1 / BS2 / người duyệt cuối cho MỌI báo cáo sinh ra
      từ chiến dịch này. Bỏ trống 1 vai trò nghĩa là KHÔNG chỉ định — bất kỳ tài khoản hợp lệ
      nào cũng ký được bước đó (giữ hành vi cũ). Chỉ áp dụng cho báo cáo <b>tạo mới SAU</b> khi
      lưu chỉ định — báo cáo đã tạo trước đó không bị đổi.
    </p>

    <div class="row">
      <div class="col-md-6">
        <BasicSelect
          label="Bác sĩ 1 (ký lần 1)"
          placeholder="Không chỉ định (ai ký trước cũng được)"
          name="assignedBs1AccountId"
          :options="accountOptions"
          track-by="id"
          value-label="displayName"
          :value.sync="assignedBs1AccountId"
        />
      </div>
      <div class="col-md-6">
        <BasicSelect
          label="Bác sĩ 2 (kiểm tra chéo)"
          placeholder="Không chỉ định (ai ký trước cũng được)"
          name="assignedBs2AccountId"
          :options="accountOptions"
          track-by="id"
          value-label="displayName"
          :value.sync="assignedBs2AccountId"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <BasicSelect
          label="Người duyệt cuối"
          placeholder="Không chỉ định (ai duyệt trước cũng được)"
          name="assignedApproverAccountId"
          :options="accountOptions"
          track-by="id"
          value-label="displayName"
          :value.sync="assignedApproverAccountId"
        />
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <LoadingButton class="btn btn-success" :handler="save">
        <i class="fas fa-save mr-2"></i>Lưu chỉ định
      </LoadingButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BcbCampaignAssignReviewers',
  props: {
    campaignId: { type: [String, Number], required: true },
  },
  data() {
    return {
      accountOptions: [],
      assignedBs1AccountId: null,
      assignedBs2AccountId: null,
      assignedApproverAccountId: null,
      initialized: false,
    };
  },
  methods: {
    async initialize() {
      if (this.initialized) return;
      this.initialized = true;
      await Promise.all([this.loadAccounts(), this.loadCurrentAssignment()]);
    },
    async loadAccounts() {
      try {
        const res = await this.$api.get('Admin/Account/portal', { params: { page: 1, size: 1000 } });
        const raw = res?.data ?? res;
        const items = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.accountOptions = items.map((acc) => ({
          id: acc.id,
          displayName: `${acc.fullName || '—'} (${acc.email || '—'})`,
        }));
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải danh sách tài khoản.' });
      }
    },
    async loadCurrentAssignment() {
      try {
        const res = await this.$api.get(`BcbCampaign/${this.campaignId}`);
        const data = res?.data ?? res;
        this.assignedBs1AccountId = data.assignedBs1AccountId || null;
        this.assignedBs2AccountId = data.assignedBs2AccountId || null;
        this.assignedApproverAccountId = data.assignedApproverAccountId || null;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải chỉ định hiện tại.' });
      }
    },
    async save() {
      try {
        const formData = new FormData();
        if (this.assignedBs1AccountId) formData.append('assignedBs1AccountId', this.assignedBs1AccountId);
        if (this.assignedBs2AccountId) formData.append('assignedBs2AccountId', this.assignedBs2AccountId);
        if (this.assignedApproverAccountId) formData.append('assignedApproverAccountId', this.assignedApproverAccountId);
        await this.$api.put(`BcbCampaign/${this.campaignId}/assign-reviewers`, formData);
        this.$toastr.s({ title: 'Thành công', msg: 'Đã lưu chỉ định người phụ trách.' });
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể lưu chỉ định.' });
      }
    },
  },
};
</script>
